// store/onboarding.ts — P1 onboarding 2-step FSM mirror.
//
// Spec: docs/contracts/aha/state_machines/onboarding.yaml.
// Holds step (0|1), selected chip, custom topic, mount timestamp for ttfv.
import { create } from 'zustand';
import type { SampleChip } from '@/lib/fixtures/sample_chips';

export type OnboardingStep = 'preview' | 'pick_topic' | 'launching' | 'launched';

interface OnboardingStore {
  step: OnboardingStep;
  mountedAt: number | null;
  selectedChip: SampleChip | null;
  customTopic: string;
  selectedIntentPreset: string | null;
  errorCode: string | null;
  setStep: (s: OnboardingStep) => void;
  recordMount: () => void;
  selectChip: (chip: SampleChip) => void;
  setCustomTopic: (text: string) => void;
  setError: (code: string | null) => void;
  reset: () => void;
}

export const useOnboarding = create<OnboardingStore>((set) => ({
  step: 'preview',
  mountedAt: null,
  selectedChip: null,
  customTopic: '',
  selectedIntentPreset: null,
  errorCode: null,
  setStep: (step) => set({ step }),
  recordMount: () => set({ mountedAt: Date.now() }),
  selectChip: (chip) =>
    set({
      selectedChip: chip,
      customTopic: '',
      selectedIntentPreset: chip.intent_preset,
    }),
  setCustomTopic: (customTopic) => set({ customTopic, selectedChip: null }),
  setError: (errorCode) => set({ errorCode }),
  reset: () =>
    set({
      step: 'preview',
      mountedAt: null,
      selectedChip: null,
      customTopic: '',
      selectedIntentPreset: null,
      errorCode: null,
    }),
}));
